var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3262 9.60183C25.3262 6.2254 22.589 3.48828 19.2125 3.48828L18.8771 3.49729C15.6566 3.67144 13.0989 6.33799 13.0989 9.60183C13.0989 12.9783 15.8361 15.7155 19.2125 15.7155L19.548 15.7064C22.7684 15.5323 25.3262 12.8658 25.3262 9.60183ZM20.9593 29.6895C20.9593 31.5984 21.4696 33.3882 22.3613 34.9297H6.98535V28.6414C6.98535 23.5622 10.8883 19.4207 15.7777 19.2168L16.1557 19.209H22.2693C23.8605 19.209 25.3571 19.6258 26.6615 20.3591C23.2759 22.0965 20.9593 25.6225 20.9593 29.6895ZM26.3062 36.7552L31.4397 33.6196L36.5733 36.7552L35.1776 30.9039L39.746 26.9906L33.7499 26.5099L31.4397 20.9557L29.1296 26.5099L23.1335 26.9906L27.7019 30.9039L26.3062 36.7552Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW10);
export default __webpack_public_path__ + "static/media/w10.b04d8071473bc0999552a015dff5f065.svg";
export { ForwardRef as ReactComponent };